<template>
  <div class="container">
    <div class="title">我的课程</div>
    <div class="content">
      <div class="content_item" v-for="(item,index) in buyList" :key="index">
        <img class="badge_img" v-if="item.is_tejia" :src='kc7Img' alt="">
        <img class="content_img" :src='item.image' alt="">
        <div class="column">
         <div class="mid_title">{{item.course_name}}</div>
          <div class="rower">
            <div class="content_mid">
              
              <div class="mid_text">{{item.description}}</div>
            </div>
        <!-- <div class="content_mid">
          <div class="mid_title">{{item.course_name}}</div>
          <div class="mid_text">{{item.description}}</div>
        </div> -->
        <div class="content_right">
          <div class="content_right_num">
            <img class="content_right_num_icon" :src='kc6Img' alt="">
            <div class="content_right_num_text">{{item.virtual_study}}人学过</div> 
          </div>
          <div class="content_right_btn" @click="detail(item.url)">查看详情</div>
        </div>
      </div>
      </div>
      </div>

  
   
      
    </div>
    <div class="title">未购买课程</div>
    <div class="content">
      <div class="content_item" v-for="(item,index) in nobuyList" :key="index">
        <img class="badge_img" v-if="item.is_tejia" :src='kc7Img' alt="">
        <img class="content_img" :src='item.image' alt="">
        <div class="column">
         <div class="mid_title">{{item.course_name}}</div>
          <div class="rower">
            <div class="content_mid">
              
              <div class="mid_text">{{item.description}}</div>
            </div>
        <!-- <div class="content_mid">
          <div class="mid_title">{{item.course_name}}</div>
          <div class="mid_text">{{item.description}}</div>
        </div> -->
        <div class="content_right">
          <div class="content_right_num">
            <img class="content_right_num_icon" :src='kc6Img' alt="">
            <div class="content_right_num_text">{{item.virtual_study}}人学过</div> 
          </div>
          <div class="content_right_btn" @click="detail(item.url)">查看详情</div>
        </div>
      </div>
      </div>
      </div>

   
      
    </div>
  </div>
</template>
<style lang="stylus" rel="stylesheet/stylus" scoped>
$rem = 100;
.column{
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  box-sizing: border-box;
  width: calc(100% - 120px) ;
}
.rower{
  display: flex;
  flex-direction: row;
  height :60px;
}
.container{
  overflow-y: scroll;
  // font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
  color: rgb(34,34,34);
}
.title{
  height :45px;
  line-height :45px;
  font-size :16px;
  font-weight :bold;
  color:rgb(34,34,34);
  padding-left 15px;
  box-sizing :border-box;
}
.content{
  width: 100%;
  margin-bottom :50px
}
.content_item{
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 90px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 15px;
  position: relative;
  display: flex;
  flex-direction: row;
}
.content_img{
  width: 150px;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  flex: 7;
}
.content_mid{
  // margin-left: 12px;
  flex: 8;
  align-items: center;
    display: flex;
}
.content_right{
  flex: 5;
  display :flex;
  flex-direction :column;
  align-items: center;
  justify-content :flex-end;
}
.mid_title{
  font-weight: 600;
  font-size: 14px;
  color: rgb(34,34,34);
  margin-top :5px;
  margin-bottom 5px;
  line-height: 24px;
 text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
}
.mid_text{
  font-size: 12px;
  color:#1b1243; 
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content_right_btn{
  width:  (200 / $rem) rem;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background-color: #B3212D;
    color: #fff;
    border-radius: 24px;
    font-size: 12px;
    margin-bottom 5px;
    margin-top :5px
}
.content_right_num{
  display :flex;
  flex-direction :row;
  justify-content :center;
  align-items :center
}
.content_right_num_icon{
  width :12px;
  height :12px;
  margin-right :2px;
}
.content_right_num_text{
  font-size 12px;
  color #879AA7;
  margin-top :1px;
}
.bottom{
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
}
.bottom_item{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottom_icon{
  width: 18px;
  height: 18px;
  margin-bottom: 5px;
}
.bottom_text{
  font-size: 14px;
  color: rgb(34,34,34);
}
.bottom_text_chose{
  font-size: 14px;
  color:#B3212D;
}

.badge_img{
   width: 55px;
  height: 55px;
  position: absolute;
    right: -3px;
    top: -3px;
}

</style>

<script>
import { recordList } from '../apollo/apollo'

export default {
   components: {
    
  },
  data() {
    return {
      kc5Img:'./static/imgs/kc5.png',
      kc6Img:'./static/imgs/kc6.png',
      kc7Img:'./static/imgs/kc7.png',
      recordList:recordList,
      buyList:[],
      nobuyList:[],
 
    }
  },
  computed:{
    
  },
  created() {
    this.getinit()
  },
  mounted(){
 
  },
  methods: {
    getinit(){
      document.title=this.$store.state.title;
      recordList().then(res=>{
        res.data.getMyCourse.map((ele,idx)=>{
          if(ele.status==1){
            this.buyList.push(ele)
          }else if(ele.status==0){
            this.nobuyList.push(ele)
          }
        })

        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    detail(url){
      window.location.href=url
    }

  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/recordList.vue